<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <div class="xixi">
      <p class="haha">123</p>
       {{$t('lang.login')}}
       <button @click="x2">1</button>
       <button @click="x1">2</button>
       <el-select v-model="value" @change="huanfu" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div class="header"></div>
      <div class="content"></div>
      <el-button>123</el-button>
      <el-checkbox>备选项</el-checkbox>
      <canvas id="colorxixi" style="width:400px;height:36px;"></canvas>
      <el-button  @click="xx()">color</el-button>
      <div id="mapcc" style="width:600px;height:600px;"></div>
    </div>
  </div>
</template>

<script>
let viewer
const Cesium = window.Cesium
let animaEntity
import {getImageShowList} from "@/api/product/index"
import { colorpicks} from "@/utils/common"
import { apiAddress,apiAddress2 } from "@/api/Home"
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
    return {
      colorLineList:[],
      options: [{
          value: 'theme1',
          label: '主题1'
        }, {
          value: 'theme2',
          label: '主题2'
        }, {
          value: 'theme3',
          label: '主题3'
        }],
        value: ''
    }
  },
  created(){
    this.getApi()
  },
  mounted(){
    this.initMap()
  },
  methods:{
    getLIST(){
        let that = this
        const startTime = '1997-09-01 00:00:00'
        const endTime = '2018-12-01 23:59:59'
        this.layerIndex = 0
        var speedIndex = 0
        var speed = 7
        let param = {
          // hbmwdNight
            productId:15,
            startTime:startTime,
            endTime:endTime
        }
        getImageShowList(param).then(res =>{
            that.AllCollection = res.data
            let bounds = JSON.parse("[107.95834604899089,16.99999682108561,121.00001271565756,25.041663487752277]")
            animaEntity = viewer.entities.add({
                rectangle: new Cesium.RectangleGraphics({
                    coordinates: Cesium.Rectangle.fromDegrees(
                        bounds[0],
                        bounds[1],
                        bounds[2],
                        bounds[3],
                    ),
                    granularity: Cesium.Math.RADIANS_PER_DEGREE * 7,
                    shadows: Cesium.ShadowMode.ENABLED,
                    material: new Cesium.ImageMaterialProperty({
                        image: new Cesium.CallbackProperty(() => {
                            if (speedIndex % speed !== 0) {
                              console.log(speedIndex);
                                speedIndex++
                                return that.AllCollection[that.layerIndex].pngUrl
                            }
                            speedIndex++
                            that.layerIndex++
                            // if(that.layerIndex===res.data.length-1||that.layerIndex>res.data.length-1){
                            //   that.layerIndex=res.data.length-1
                            //   that.layerIndex = 0
                            // }
                            if(that.layerIndex<res.data.length-1){
                              return that.AllCollection[that.layerIndex].pngUrl
                            }else{
                              that.layerIndex=res.data.length-1
                              that.layerIndex = 0
                              return that.AllCollection[that.layerIndex].pngUrl
                            }
                        },false),
                        transparent: true
                    })
                })
            })
            
            if(that.isFirst){
                viewer.flyTo(animaEntity)
                that.isFirst = false
            }
        })
    },
    initMap(){
        Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NjJhZTlhZC00ZjE4LTRhYjYtYWI5Zi02MDQ3YjA1OTI5NjAiLCJpZCI6NjEwNTMsImlhdCI6MTYyNTY0ODgwMX0.BfdY8ePnShWrZomg9sv4dz8G5EG28Jva1dVFgmE7En4';
        viewer = new Cesium.Viewer('mapcc',{
            animation: false, //创建动画部件
            shouldAnimate : true,
            orderIndependentTranslucency: false,
            contextOptions: {
              webgl: { alpha: true},
              requestWebgl2: true,
              maxDrawingBufferWidth: 3840,
              maxDrawingBufferHeight: 2160
            },
        });

          try {
              this.getLIST()
          } catch (error) {
              console.log(error);
          }
    },
    xx(){
      colorpicks(['#FFFF00','#666666','#005500'],75)
    },
    getStepList(val,step){
      let a = parseInt(val/step)
      let b = val%step
      let c = []
      for(let i=0;i<step;i++){
        c.push(a)
      }
      for(let i=0;i<b;i++){
        c[i] = c[i]+1
      }
      console.log(c);
      return c
    },
    colorpick(a1,stepall1){
      this.colorLineList = []
      let a = a1
      let stepall = stepall1
      // let step = parseInt(stepall/a.length-1)
      let step = this.getStepList(stepall,a.length-1)
      
      let colorIndex = 0
      while (a.length>1&&colorIndex!=a.length-1) {
        this.gradientColor(a[colorIndex],a[colorIndex+1],step[colorIndex])
        colorIndex++
      }
      var can = document.getElementById("colorxixi");
      var cans = can.getContext('2d');
      //创建一个线性渐变对象
      console.log(this.colorLineList);
      var gnt1 = cans.createLinearGradient(0,0,300,0);
      this.colorLineList.forEach((element,index) => {
          gnt1.addColorStop(index*(1/this.colorLineList.length),element);
      });
      cans.fillStyle = gnt1;
      //绘制一个矩形
      cans.fillRect(0,0,1000,1000);
    },
    gradientColor(startColor,endColor,step){
        let startRGB = this.colorToRgb(startColor);//转换为rgb数组模式
        let startR = startRGB[0];
        let startG = startRGB[1];
        let startB = startRGB[2];

        let endRGB = this.colorToRgb(endColor);
        let endR = endRGB[0];
        let endG = endRGB[1];
        let endB = endRGB[2];

        let sR = (endR-startR)/step;//总差值
        let sG = (endG-startG)/step;
        let sB = (endB-startB)/step;

        var colorArr = [];
        for(var i=0;i<step;i++){
            var hex = this.colorToHex2('rgb('+parseInt((sR*i+startR))+','+parseInt((sG*i+startG))+','+parseInt((sB*i+startB))+')');
            colorArr.push(hex);
        }
        console.log(colorArr);
        this.colorLineList = [...this.colorLineList,...colorArr]
        return colorArr;
    },

        // 将hex表示方式转换为rgb表示方式(这里返回rgb数组模式)
    colorToRgb(ssColor){
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        var sColor = ssColor.toLowerCase();
        if(sColor && reg.test(sColor)){
            if(sColor.length === 4){
                var sColorNew = "#";
                for(var i=1; i<4; i+=1){
                    sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
                }
                sColor = sColorNew;
            }
            //处理六位的颜色值
            var sColorChange = [];
            for(var c=1; c<7; c+=2){
                sColorChange.push(parseInt("0x"+sColor.slice(c,c+2)));
            }
            return sColorChange;
        }else{
            return sColor;
        }
    },

        // 将rgb表示方式转换为hex表示方式
    colorToHex(rgb){
        var _this = rgb;
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        if(/^(rgb|RGB)/.test(_this)){
            var aColor = _this.replace(/(?:\(|\)|rgb|RGB)*/g,"").split(",");
            var strHex = "#";
            for(var i=0; i<aColor.length; i++){
                var hex = Number(aColor[i]).toString(16);
                hex = hex<10 ? 0+''+hex :hex;// 保证每个rgb的值为2位
                if(hex === "0"){
                    hex += hex;
                }
                strHex += hex;
            }
            if(strHex.length !== 7){
                strHex = _this;
            }

            return strHex;
        }else if(reg.test(_this)){
            var aNum = _this.replace(/#/,"").split("");
            if(aNum.length === 6){
                return _this;
            }else if(aNum.length === 3){
                var numHex = "#";
                for(var m=0; m<aNum.length; m+=1){
                    numHex += (aNum[m]+aNum[m]);
                }
                return numHex;
            }
        }else{
            return _this;
        }
    },
    colorToHex2(data){
      let reg = /^(rgb|RGB)/;
      let color = data;
      if (reg.test(color)) {
          let strHex = "#";
          // 把RGB的3个数值变成数组 
          let colorArr = color.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
          // 转成16进制 
          for (let i = 0; i < colorArr.length; i++) {
              let hex = Number(colorArr[i]).toString(16);
              if (hex.length == "1") { hex = "0" + hex; }
              strHex += hex;
          }
          return strHex;
      }
      else { return color.toString(); }
    },
    huanfu(val){
      console.log(val);
      window.document.documentElement.setAttribute('data-theme', val)
    },
    getApi(){
      apiAddress({                    
          type: 0,                    
          sort: 1                
      }).then(res => {
          // 获取数据成功后的其他操作
          console.log(res);
      })


      apiAddress2({                    
          type: 0,                    
          sort: 1                
      }).then(res => {
          // 获取数据成功后的其他操作
          console.log(res);
      })  
    },
    x2(){
      this.$i18n.locale = 'zh';
    },
    x1(){
      this.$i18n.locale = 'en';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.xixi{
  .haha{
    color: red;
  }
  .header{
    width: 100%;
    height: 60px;
    @include bg_color();
  }
  .content{
    @include notice_bg_color();
    width: 100%;
    height: 100px;
  }
}
</style>
